import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { CalendarEvent } from '@ils/evaluation-scheduler/db/calendarEvent.js';
import { subscribeMyCalendarEventsResolver } from '@ils/evaluation-scheduler/server/resolver.js';

export const subscribeMyCalendarEvents = registerSubscription({
  operationName: 'subscribeMyCalendarEvents',
  resolve: subscribeMyCalendarEventsResolver,
  type: type => [CalendarEvent],
  params: [
    { name: 'start', type: () => Date },
    { name: 'end', type: () => Date },
  ],
});
